import React from 'react';

const ShowFileModal = (props) => {
  const { fileName, fileBase64 } = props; 
  return (
    <div className="f-10">
      <img src={fileBase64} alt={fileName} />
    </div>
  );
}

export default ShowFileModal;